export default __webpack_public_path__ + "static/media/amex.685cf121.svg";